import { Swiper, Navigation, Pagination, Thumbs, Controller } from 'swiper';
import elementExists from '../../utils/elementExists';
import eventBus from '../../core/services/event-bus';

const ProductImagesSwiper = function(){
 
    const swiperProduct = document.querySelector('.product-single__images');
    if (elementExists(swiperProduct)) {
        const swiperProductThumb = swiperProduct.querySelector( '.swiper-product-thumbs' );
        const swiperProductMain = swiperProduct.querySelector( '.swiper-product-main' );
        const thumbsWrap = swiperProduct.querySelector( '.thumbs-wrap' );
        
        // Product - Thumbs
        if ( elementExists(swiperProductMain) ) {
            const hasThumbs = elementExists( swiperProductThumb );

            // Product - Main Image
            const swiperMain = new Swiper( swiperProductMain , {
                direction: 'horizontal',
                slidesPerView: 1,
                spaceBetween: 15,
                loop: false,
                allowTouchMove : ( hasThumbs ? true : false ),
                loopedSlides: 9
            })
            
            if( hasThumbs){
                const btnNext = thumbsWrap.querySelector('.swiper-button-next');
                const btnPrev = thumbsWrap.querySelector('.swiper-button-prev');
                const numSlides = swiperProductThumb.dataset.numSlides;
    
                const swiperThumbs = new Swiper( swiperProductThumb , {
                    direction: 'horizontal',
                    slidesPerView: ( numSlides < 4  ? 2 : 4 ),
                    spaceBetween: 5,
                    slideToClickedSlide: true,
                    centeredSlides: true,
                    loop: false,
                    // loopedSlides: 9,
                    navigation: {
                        nextEl: btnNext,
                        prevEl: btnPrev,
                    },
                    // breakpoints: {
                    //     1192: {
                    //         slidesPerView: 3,
                    //         spaceBetween: 5
                    //     },
                    //     1440: {
                    //         slidesPerView: 4,
                    //         spaceBetween: 5
                    //     }
                    // }
                })
                // Controllers
                swiperThumbs.controller.control = swiperMain;
                swiperMain.controller.control = swiperThumbs;   
            }
                
            eventBus.on(eventBus.types.OptionsSelected , function( $event ){
                const variantId = $event.detail.id;
                const imageSlides = swiperProductMain.querySelectorAll( '.swiper-slide:not(.swiper-slide-duplicate');
                imageSlides.forEach( el => {
                    const data = el.dataset;
                    if( data.variantIds   ){
                        if( data.variantIds.indexOf( variantId ) > -1 ){
                            swiperMain.slideToLoop( data.swiperSlideIndex , 0 );
                        } 
                    }
                })
            })
        }
        
    }
    
}

export default ProductImagesSwiper;